import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { concatMap } from 'rxjs/operators';
import { Actions } from '../../actions';
import { GetCatalog } from '../action-creators';
import { LOGIN_USER_SUCCESS } from '../../auth/actions';

export const getUserCatalogEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions>(LOGIN_USER_SUCCESS),
    concatMap(() => [new GetCatalog()])
  );
